import React, { useEffect } from "react";
import { withRouter } from "react-router";
import styled from "styled-components";

const PageWrapper = styled.div`
  position: fixed;
  inset: 0;
  min-height: 100vh;
  background: #345038;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-family: "Roboto Condensed", sans-serif;
  text-align: center;
  color: white;
`;

const Card = styled.div`
  width: 100%;
  max-width: 520px;
  border-radius: 16px;
  padding: 16px;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;

  @media (min-width: 480px) {
    font-size: 26px;
  }

  @media (min-width: 768px) {
    font-size: 40px;
  }
`;

const Message = styled.p`
  font-size: 15px;
  line-height: 1.6;
  margin-top: 0;
  margin-bottom: 32px;
  font-weight: 300;

  @media (min-width: 480px) {
    font-size: 20px;
  }
`;

const Date = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;

  @media (min-width: 480px) {
    font-size: 20px;
  }
`;

const Footer = styled.div`
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 32px;

  @media (min-width: 480px) {
    font-size: 20px;
  }
`;

const Icon = styled.div`
  fill: white;
  width: 150px;
  margin: auto;
`;

const CustomLink = styled.a`
  color: white;
  text-decoration: none;
`;

class MaintenancePage extends React.Component {
  componentDidMount() {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  render() {
    return (
      <PageWrapper>
        <Card>
          <Icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1775.01 588.12"
            >
              <g>
                <path d="M1742.54.16L32.5,0C14.62,0,0,14.78,0,32.63v393.25c0,18,14.62,32.63,32.5,32.63h1710.03c17.82,0,32.47-14.63,32.47-32.63V32.63c0-17.85-14.65-32.47-32.47-32.47ZM1749.48,430.27H27.45V26.24h1722.03v404.03Z" />
                <path d="M1609.94,228.81c36.94,0,66.88-29.92,66.88-66.86s-29.95-66.86-66.88-66.86h-394.61c-2.48,0-4.54,2.01-4.54,4.49v258.43c0,2.48,2.06,4.49,4.54,4.49h394.61c36.94,0,66.88-29.92,66.88-66.83s-29.95-66.86-66.88-66.86M1536.38,317.77h-215.43v-57.57h215.43c15.89,0,28.76,12.9,28.76,28.79s-12.87,28.79-28.76,28.79M1536.38,196.41h-215.43v-57.55h215.43c15.89,0,28.76,12.87,28.76,28.76s-12.87,28.79-28.76,28.79" />
                <path d="M925.18,98.7c-1.62-1.88-4.95-3.4-7.43-3.4h-97.94c-2.48,0-5.8,1.52-7.4,3.43l-222.99,260.26c-1.6,1.88-.88,3.4,1.55,3.4h67.87c2.47,0,5.83-1.52,7.4-3.4l41.99-49.34c1.6-1.91,4.93-3.43,7.4-3.43l253.32-.15c2.5,0,5.83,1.55,7.46,3.4l42.74,49.55c1.62,1.86,4.95,3.38,7.45,3.38h121.95c2.47,0,3.2-1.52,1.55-3.38l-224.92-260.31ZM748.16,264.66c-2.48,0-3.17-1.55-1.55-3.4l93.32-106.66c1.6-1.86,4.31-1.88,5.96-.03l94.97,106.73c1.65,1.83.95,3.35-1.52,3.35h-191.18Z" />
                <path d="M1712.87,52.95c3.53,0,6.89.98,10.29,2.73,3.38,1.96,5.96,4.54,7.89,7.89,1.88,3.38,2.86,6.94,2.86,10.45,0,3.71-.98,7.27-2.86,10.45-1.81,3.4-4.36,5.93-7.74,7.92-3.38,1.75-6.91,2.71-10.44,2.71s-7.28-.95-10.47-2.71c-3.35-1.99-5.94-4.51-7.87-7.92-1.75-3.17-2.71-6.73-2.71-10.45,0-3.51.95-7.07,2.71-10.45,1.93-3.35,4.52-5.93,7.87-7.89,3.38-1.75,6.94-2.73,10.47-2.73M1712.87,56.51c-3.07,0-5.94.77-8.69,2.24-2.74,1.62-4.98,3.69-6.6,6.63-1.57,2.71-2.24,5.57-2.24,8.64,0,3.07.67,5.96,2.24,8.69,1.62,2.89,3.74,4.98,6.45,6.6,2.91,1.6,5.78,2.22,8.85,2.22,3.04,0,5.93-.62,8.67-2.22,2.76-1.62,5-3.71,6.42-6.6,1.6-2.73,2.42-5.62,2.42-8.69s-.82-5.93-2.42-8.64c-1.6-2.94-3.66-5-6.58-6.63-2.71-1.47-5.62-2.24-8.51-2.24M1703.53,85.78v-22.7h7.89c2.58,0,4.49.18,5.78.64,1.11.31,2.09,1.13,2.73,2.12.8,1.11,1.11,2.24,1.11,3.38,0,1.62-.62,3.02-1.75,4.31-1.11,1.13-2.73,1.96-4.64,2.09.77.34,1.45.67,1.91,1.13.82.98,1.93,2.42,3.2,4.54l2.92,4.49h-4.49l-2.09-3.71c-1.45-2.73-2.74-4.49-3.72-5.13-.8-.64-1.75-.8-3.04-.8h-2.11v9.65h-3.69ZM1707.22,72.89h4.51c2.09,0,3.53-.31,4.36-.98.62-.44,1.11-1.39,1.11-2.37,0-.64-.15-1.32-.65-1.78-.33-.62-.8-.95-1.42-1.29-.64-.15-1.96-.31-3.71-.31h-4.2v6.73Z" />
                <path d="M433.28,96.08H99.56c-2.5,0-4.57,2.06-4.57,4.57v177.87c0,2.53,2.07,4.57,4.57,4.57l105.21-.26c2.53,0,4.57-2.04,4.57-4.57l-.21-123.19c0-2.53,2.06-4.57,4.57-4.57h106.5s3.51,0,3.51,0h58.22c44.34,0,80.32,35.98,80.32,80.35,0,44.34-35.98,80.32-80.32,80.32H99.56c-2.5,0-4.57,2.06-4.57,4.59v47.28c0,2.53,2.07,4.59,4.57,4.59h333.72c71.27,0,129.02-57.8,129.02-129.07v-13.44c0-71.27-57.75-129.05-129.02-129.05" />
              </g>
            </svg>
          </Icon>
          <Title>Scheduled Maintenance</Title>
          <Message>
            Dear User, the DSHOP portal is currently <br /> undergoing
            maintenance for an update.
          </Message>
          <Date>It will be back online on December 10th.</Date>
          <Footer>Thanks for your patience.</Footer>
          <CustomLink href="mailto:dshop.orders@dabpumps.com">
            dshop.orders@dabpumps.com
          </CustomLink>
        </Card>
      </PageWrapper>
    );
  }
}

export default withRouter(MaintenancePage);



// WEBPACK FOOTER //
// ./src/components/maintenance/index.js